module.exports = "/_next/static/images/calculator-monotone-0c9173cdb42adfb89634e0ebddc21ef1.svg";